export enum CumulativeBoosterID
{
  InfiniteBalls = 0,
  BigBall = 1,
  Fireworks = 2,
  Multiball = 3,
  Dynamite = 4,
  Rocket = 5,
  Mine = 6
}

/** Stable LiveOps id; do not use the numeric enum value in offer configs. */
export type CumulativeBoosterOfferType = 'infinite_balls' | 'big_ball' | 'fireworks' | 'multi_balls' | 'dynamite' | 'rocket' | 'mines';

export function cumulativeBoosterOfferType( id: CumulativeBoosterID ): CumulativeBoosterOfferType
{
  switch ( id )
  {
    case CumulativeBoosterID.InfiniteBalls: return 'infinite_balls';
    case CumulativeBoosterID.BigBall: return 'big_ball';
    case CumulativeBoosterID.Fireworks: return 'fireworks';
    case CumulativeBoosterID.Multiball: return 'multi_balls';
    case CumulativeBoosterID.Dynamite: return 'dynamite';
    case CumulativeBoosterID.Rocket: return 'rocket';
    case CumulativeBoosterID.Mine: return 'mines';
  }
}
